module.exports = __webpack_public_path__ + "static/media/number5.3798b3f9.svg";